import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useForm } from 'antd/lib/form/Form';

import ThirdPartyIntegration from 'services/thirdPartyIntegrationService';
import './TingeeThirdParty.scss';
import { THIRDPARTY_CODE } from 'constants/app';
import useThirdPartyConfigForm from './hooks/useThirdPartyConfigForm';
import ThirdPartyConfigLayout from './components/ThirdPartyConfigLayout';

const VNPAY_OFFLINE_CREATE_QR_URL = process.env.REACT_APP_VNPAY_QR_OFFLINE_URL
  || 'https://doitac-tran.vnpay.vn/QRCreateAPIRestV2/rest/CreateQrcodeApi/createQrcode';

const VnpayBusinessOfflineThirdParty = ({ id, setOpenContent, setId }) => {
  const { t: translation } = useTranslation();
  const [form] = useForm();

  const {
    loading,
    isConnected,
    hasFormChanged,
    showConfirmTest,
    setShowConfirmTest,
    handleSubmit,
    handleConfirmAndSave,
    handleValuesChange,
  } = useThirdPartyConfigForm({
    id,
    setId,
    form,
    translation,
    thirdPartyCode: THIRDPARTY_CODE.VNPAY_BUSINESS,
    mapFromPartyRequiredData: (partyRequiredData = {}, res = {}) => ({
      vnpayQROfflineAppId: partyRequiredData?.vnpayQROfflineAppId || '',
      vnpayQROfflineMerchantName: partyRequiredData?.vnpayQROfflineMerchantName || '',
      vnpayQROfflineMerchantType: partyRequiredData?.vnpayQROfflineMerchantType || '',
      vnpayQROfflineMerchantCode: partyRequiredData?.vnpayQROfflineMerchantCode || '',
      vnpayQROfflineTerminalId: partyRequiredData?.vnpayQROfflineTerminalId || '',
      vnpayQROfflineCreateQRSecret: partyRequiredData?.vnpayQROfflineCreateQRSecret || '',
      isEnable: res?.partyEnableStatus === 1,
    }),
    buildTestPayload: (values = {}) => ({
      vnpayQROfflineAppId: values.vnpayQROfflineAppId,
      vnpayQROfflineMerchantName: values.vnpayQROfflineMerchantName,
      vnpayQROfflineMerchantType: values.vnpayQROfflineMerchantType,
      vnpayQROfflineMerchantCode: values.vnpayQROfflineMerchantCode,
      vnpayQROfflineTerminalId: values.vnpayQROfflineTerminalId,
      vnpayQROfflineURL: VNPAY_OFFLINE_CREATE_QR_URL,
      vnpayQROfflineCreateQRSecret: values.vnpayQROfflineCreateQRSecret,
      amount: 10000,
    }),
    buildUpdatePayload: (values = {}, isConnectedLocal) => ({
      data: {
        partyRequiredData: {
          vnpayQROfflineAppId: values.vnpayQROfflineAppId,
          vnpayQROfflineMerchantName: values.vnpayQROfflineMerchantName,
          vnpayQROfflineMerchantType: values.vnpayQROfflineMerchantType,
          vnpayQROfflineMerchantCode: values.vnpayQROfflineMerchantCode,
          vnpayQROfflineTerminalId: values.vnpayQROfflineTerminalId,
          vnpayQROfflineURL: VNPAY_OFFLINE_CREATE_QR_URL,
          vnpayQROfflineCreateQRSecret: values.vnpayQROfflineCreateQRSecret,
        },
        partyActiveStatus: isConnectedLocal ? 1 : 0,
        partyEnableStatus: values.isEnable ? 1 : 0,
      },
    }),
    testApi: ThirdPartyIntegration.testConfigsVnpayBusiness,
    updateApi: ThirdPartyIntegration.updateConfigsVnpayBusiness,
  });

  return (
    <ThirdPartyConfigLayout
      loading={loading}
      form={form}
      translation={translation}
      title={`Cài đặt tài khoản ${translation('expand_setting.VNPAY_BUSINESS')}`}
      isConnected={isConnected}
      hasFormChanged={hasFormChanged}
      onBack={() => setOpenContent('')}
      onFinish={handleSubmit}
      onValuesChange={handleValuesChange}
      showConfirmTest={showConfirmTest}
      setShowConfirmTest={setShowConfirmTest}
      onConfirmAndSave={handleConfirmAndSave}
    >
      <Form.Item required label='App ID' name='vnpayQROfflineAppId' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Merchant Name' name='vnpayQROfflineMerchantName' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Merchant Type' name='vnpayQROfflineMerchantType' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Merchant Code' name='vnpayQROfflineMerchantCode' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Terminal ID' name='vnpayQROfflineTerminalId' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item required label='Secret Key' name='vnpayQROfflineCreateQRSecret' rules={[{ required: true, message: translation('isReq') }]}>
        <Input type='text' />
      </Form.Item>
    </ThirdPartyConfigLayout>
  );
};

export default VnpayBusinessOfflineThirdParty;
